import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Level} from '../../classes/level/level';
import {User} from '../../classes/user/user';
import {TranslateService} from '@ngx-translate/core';
import {UsersConstants} from '../../constants/users.constants';
import ROLES = UsersConstants.ROLES;


@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private http: HttpClient,
                private translate: TranslateService) {
    }

    getUsers(levelId: number, active: boolean, role: string, includeMyLevel: boolean = false) {
        let activeNumber: number = active === true ? 1 : 0;
        role = role.replace('ROLE_', '').toLocaleLowerCase();
        let roleArray: any[] = role.split(',');
        role = '';
        roleArray.forEach(r => {
            role += `&roles[]=` + r;
        });
        let include_my_level: string = includeMyLevel === true ? `&include_my_level=1` : `&include_my_level=0`;
        return this.http.get(`users?active=` + activeNumber + `&level=` + levelId + include_my_level + role );
    }

    public getUser(id: number) {
        return this.http.get(`users/` + id);
    }

    public postUser(user: User) {

        return this.http.post(`users`, user);
    }

    public patchUser(id, user: User) {
        return this.http.patch(`users/` + id, user);
    }

    public getClientOrInstallerRoles(roles: any[]) {
        let role: any[] = [];
        roles.forEach((r) => {
            if (r === ROLES.ROLE_CLIENT || r === ROLES.ROLE_INSTALLER) {
                role.push(this.translate.instant('SHORT_' + r));
            }
        });
        return role;
    }

}
